import Page from "./../src/client/pages/glance";
export default Page;
